import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Table, Empty, Tooltip, Modal, Form, Input, Button, notification, message, Spin
} from "antd";

import RequestHandler from "util/RequestHandler";

import moment from "moment/moment";
import {odata} from "../Filters/Helper";
import {DownloadOutlined, FilePdfOutlined, MailFilled, MailOutlined} from "@ant-design/icons";
import Iframe from "react-iframe";
import RiskAnalysisTableFilter from "../Filters/RiskAnalysisTableFilter";


const List = ({activeTabKey}) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });

  const [loading, setLoading] = useState(false);
  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [EmailVisible, setEmailVisible] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdf, setPdf] = useState("");
  const [Email, setEmail] = useState(localStorage.getItem("email"));

  const [documentNumber, setDocumentNumber] = useState("");
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    getTableData();
  }, [tableDataQueryOptions, activeTabKey]);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    let query = "";

    if (filter.length > 0) {
      query = "$filter=" + filter;
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take, filter, order } = tableDataQueryOptions;

    RequestHandler.get(
      `/RiskAnalysis?$count=true&${getFilterQuery()}&${order}&$skip=${skip}&$top=${take}`,
      false
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });

  }

  const paging = (p, _, sorter) => {
    let orderValue = "";
    if (sorter.columnKey && sorter.order) {
      orderValue =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.column.key)
          : odata.orderByDesc(sorter.column.key));
    }

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        order: orderValue,
      };
    });
  };

  const downloadPdf = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);


    const byteCharacters = atob(pdf); // Base64 decode
    const byteArrays = [];


    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }


    const blob = new Blob(byteArrays, { type: 'application/pdf' });


    const fileName = `${companyName}-Risk Analizi.pdf`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    setIsModalVisible(true);
    hide();
  };

  const showReport = (documentId, name, success) => {

    if(success) {
      setLoading(true);
      setCompanyName(name);
      setDocumentNumber(documentId);

      RequestHandler.get(`/RiskAnalysis/pdf/${documentId}`).then((pdfResponse) => {

        const url = `data:application/pdf;base64,${pdfResponse.base64String}`;
        setPdfUrl(url);
        setPdf(pdfResponse.base64String)

        setIsModalVisible(true);
        setLoading(false);
      });

      return true;
    }

    return false;
  };

  const columns = [
    {
      title: "Firma",
      dataIndex: "firmName",
    },
    {
      title: "Oluşturan",
      dataIndex: "creator"
    },
    {
      title: "Tarih",
      dataIndex: "addDate",
      render: (data) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Rapor",
      dataIndex: "documentId",
      width: "1%",
      align: "center",
      render: (data, row) => {

        return (
          <Tooltip title={row.isSuccess ? "" : "Fray analizi başarısız oldu."}>
            <a
              style={{ color: `${row.isSuccess ? "red" : "black"}`, fontSize: "130%" }}
              onClick={() =>  showReport(data, row.firmName, row.isSuccess)  }
            >
              {" "}
              <FilePdfOutlined />
            </a>
          </Tooltip>
        );
      },
    }
  ];

  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };

  const sendMail = () => {
    setLoading(true);
    if (Email.length > 0) {
      RequestHandler.get(
        `/RiskAnalysis/sendEmail/${documentNumber}/${Email}/${companyName}`).then(() => {
        setLoading(false);
      });
    } else {
      notification.error({
        description: "Mail adresi girilmedi.",
        duration: 3,
      });
      setLoading(false);
    }
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        skip: 0,
        current: 1,
        take: prevState.take,
        filter: query,
      };
    });
  };


  return (
    <>
      <RiskAnalysisTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row id="tableArea">

        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(record, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.pageSize,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal
        title={`${companyName} - Risk Analiz Raporu`}
        width={1000}
        style={{ height: 1000 }}
        visible={isModalVisibleReceipt}
        onOk={handleOkReceipt}
        onCancel={handleOkReceipt}
        footer={null}
      >
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          fields={[{ name: "Email", value: Email }]}
        >
          <Row>
            <Col span={20}></Col>
            <Col span={2}>
              {EmailVisible ? (
                <MailOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              ) : (
                <MailFilled
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              )}
            </Col>
            <Col span={2}>
              <DownloadOutlined
                style={{ fontSize: 20, marginBottom: 20 }}
                onClick={() => downloadPdf()}
              />
            </Col>
          </Row>
          <Row hidden={EmailVisible}>
            <Col span={18}>
              <Form.Item
                label="Mail Adresi"
                name="Email"
                style={{ width: "100%" }}
              >
                <Input value={Email} onChange={onChangeEmail} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => sendMail()}
                  loading={loading}
                >
                  Gönder
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Iframe
          url={pdfUrl}
          width="100%"
          height="1000px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>
    </>
  );
};


export default List;
